import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

export const validatorSupplier = v.object({
  code: v.optional(v.string()),
  taxId: v.optional(v.string()),
  companyName: v.optional(v.string()),
  contactPerson: v.optional(v.string()),
  phone: v.optional(v.string()),
  email: v.optional(v.string()),
  address: v.optional(v.string()),

  internalControl: internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});
export const suppliers = defineTable(validatorSupplier)
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_name", ["companyName"])
  .index("by_email", ["email"])

  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_status", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])

  .searchIndex("search_suppliers", {
    searchField: "companyName",
    filterFields: ["internalControl.companyId", "internalControl.state"],
  })
  .searchIndex("search_suppliers_contact_person", {
    searchField: "contactPerson",
    filterFields: ["internalControl.companyId", "internalControl.state"],
  });
